import {
  Compiler,
  Component,
  EventEmitter,
  Injector,
  Input,
  NgModuleFactory,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { IComboboxStyle } from '../../../base/src/abcCombobox/abcCbxGrid';
import { ComponentStyle } from '../../../base/src/abcComponent.model';
import { AbcComponentService } from '../../../base/src/abcComponent.service';
import { GridStyle, IGrid } from '../../../base/src/abcGrid/abcGrid';
@Component({
    selector: '',
    template: `
    <mat-form-field class="matFormField no-padding" id="{{ id }}">
      <mat-label>{{ label }}</mat-label>
      <mat-select
        #matSelect
        id="{{ id }}"
        backdropClass="popupBackdropClass"
        [(ngModel)]="value"
        (ngModelChange)="dataChanged(selectedValueRow)"
        disabled="{{ readOnly }}"
        panelClass="selectStyle"
      >
        <mat-select-trigger>
          {{ selectedValue }}
        </mat-select-trigger>
        <mat-option [value]="selectedValue" disabled #matOptions>
          <ng-template #comboGrid></ng-template>
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
    styleUrls: ['./matSelect.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class MatSelectComponent implements OnInit {
  @Input('label') label: string;
  @Input() class: string;
  // Used to swap between grid style (JqGrid Or DevExGrid) into mat-select
  @Input() materialGridStyle: ComponentStyle = 2;
  @ViewChild('comboGrid', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @ViewChild('matSelect', { static: true }) matSelect: MatSelect;
  @ViewChild('matOptions') matOption: MatOption;
  @Output() onComboClick: EventEmitter<any> = new EventEmitter();
  @Output() onChange: EventEmitter<any> = new EventEmitter();

  @Input() selectedValue;
  selectedValueRow;
  value: string;
  id: string;
  private componentRef;
  datafields;
  source: any;
  columns: any;
  dataAdapter: any;
  readOnly: boolean = false;

  constructor(
    private abcComponentService: AbcComponentService,
    private renderer2: Renderer2,
    private compiler: Compiler,
    private injector: Injector
  ) {}
  ngOnInit(): void {}
  ngAfterViewInit() {
    if (this.class) {
      const element = this.matSelect._elementRef.nativeElement;
      this.renderer2.addClass(element, this.class);
    }
  }

  dataChanged(value) {
    this.onChange.emit(value);
  }

  setSelectStyle(style: IComboboxStyle) {
    const element = this.matSelect._elementRef.nativeElement;
    if (style) {
      if (style.disabled == true) {
        this.readOnly = true;
      }
      for (let key in style) {
        element.style[key] = style[key];
      }
    }
  }

  public onComboboxOpen(columnsHeader, data, viewKey) {
    // Disabling the mat option and deselcting it is due to the integration of the JqGrid inside
    this.matOption.disabled = true;
    if (this.matOption.value) {
      this.selectedValue = this.matOption.value;
    }
    // this.matOption.deselect();
    if (!this.componentRef) {
      const gridStyle: GridStyle = {
        height: "'100%'",
        width: "'100%'",
      };
      const gridAttr: IGrid = {
        columnsHeader: columnsHeader,
        gridData: data,
        id: this.id,
        setGridStyle: (style) => (style = gridStyle),
      };

      switch (this.materialGridStyle) {
        case 4: {
          import('../../../devExtreme/src/devExGrid/devExGrid.module').then((module) => {
            this.compiler.compileModuleAsync(module.DevExGridModule).then((moduleFactory: NgModuleFactory<any>) => {
              const moduleRef = moduleFactory.create(this.injector);
              const componentFactory = moduleRef.instance.resolveComponent();
              this.componentRef = this.abcComponentService.loadComponent(
                componentFactory.componentType,
                this.viewContainerRef
              ).componentRef.instance;
              this.componentRef.columns = columnsHeader;
              this.componentRef.visible = true;
              this.componentRef.onSelectionChanged.subscribe((event) => {
                let data = event.event;
                this.matOption.disabled = false;
                if (data) {
                  this.selectedValue = data.key;
                  if (data.data.Id) {
                    this.selectedValueRow = data.data.Id;
                    this.matSelect.value = data.data.Id;
                  } else {
                    this.selectedValueRow = data.data.Value;
                    this.matSelect.value = data.data.Value;
                  }
                }
              });
              this.componentRef.gridData = data;
              this.componentRef.id = this.id;
              this.componentRef.keyExpr = viewKey;
              this.componentRef.setGridStyle(gridAttr.setGridStyle());
            });
          });
          break;
        }
      }
    }
  }
}
